<template>
    <CContainer>
        <CRow>
            <h6>
                 Esta sección le permite conocer el Estado de Cuenta de la empresa con el proveedor, acá se detalla cada uno de los documentos que adeuda o tiene a favor el cliente y los abonos realizados respectivamente en cada documento. 
            </h6>
        </CRow>
        <CCard
          class="bg-light border-0 mt-4 mb-1">
          <CCardBody>
            <CDropdown
              color="dark"
              :caret="false"
              class="d-inline-block">
              <template v-slot:toggler>
                <CButton
                  color="dark">
                  <CIcon name="cil-cloud-download"/>
                  <span class="align-middle mr-2">Descargar</span>
                </CButton>
              </template>
              <CDropdownItem>
                <template v-slot:default>
                  <json-excel
                    :fields="fileFields"
                    :data="items"
                    name="estadocuenta.xls"
                    class="w-100">
                    Excel
                  </json-excel>
                </template>
              </CDropdownItem>
              <CDropdownItem>
                <template v-slot:default>
                  <json-excel
                    :fields="fileFields"
                    :data="items"
                    type="csv"
                    name="estadocuenta.csv"
                    class="w-100">
                    CSV
                  </json-excel>
                </template>
              </CDropdownItem>
            </CDropdown>
          </CCardBody>
        </CCard>
        <CCard class="mt-4">
        <CCardBody class="p-3">
          <CDataTable
            :items="items"
            :fields="fields"
            hover
            pagination
            :tableFilter="{label: 'Buscar: ', placeholder:' '}"
            :items-per-page-select="{label:'Items por página', values: [10, 20, 50]}"
            :items-per-page="10">
            <template #Valor_Saldo="{item}">
              <td align="right">{{formatter.format(item.Valor_Saldo)}}</td>
            </template>
            <template #Documento="{item}">
              <td align="right">{{(item.Documento)}}</td>
            </template>
            <template #Fecha_Emision="{item}">
              <td align="right">{{(item.Fecha_Emision)}}</td>
            </template>
            <template #Fecha_Vencimiento="{item}">
              <td align="right">{{(item.Fecha_Vencimiento)}}</td>
            </template>
            <!-- <template #Valor_ReteIVA="{item}">
              <td align="right">{{formatter.format(item.Valor_ReteIVA)}}</td>
            </template>
            <template #Valor_ReteFuente="{item}">
              <td align="right">{{formatter.format(item.Valor_ReteFuente)}}</td>
            </template>
            <template #Valor_ReteICA="{item}">
              <td align="right">{{formatter.format(item.Valor_ReteICA)}}</td>
            </template>
            <template #Valor_Abonos="{item}">
              <td align="right">{{formatter.format(item.Valor_Abonos)}}</td>
            </template>
            <template #Valor_Total="{item}">
              <td align="right">{{formatter.format(item.Valor_Total, 0)}}</td>
            </template> -->
            <template #btn="{item}">
              <td >
                <CButton 
                  color="info"
                  square
                  size="sm"
                  @click="
                    detailedItem = {...item}
                    detailModal = true
                  ">
                  <CIcon name="cil-lightbulb"/>
                </CButton>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    <CModal
            title=""
            color="dark"
            :show.sync="detailModal"
            :centered="true"
            :closeOnBackdrop="false"
            :backdrop="true"
            >
            <template v-slot:header>
                <h4>Detalle Estado de Cuenta</h4>
            </template>
            <template v-slot:body-wrapper>
                <CContainer class="p-4">   
                  <CRow v-for="(key) in Object.keys(detailedItem)" :key="key">
                    <CCol :sm="6" v-if="!renderExceptions.includes(key)">
                      <span class="text-muted font-weight-bold text-capitalize col-sm-6">{{replace_(key)}}: </span>
                    </CCol> 
                    <CCol :sm="6" v-if="!renderExceptions.includes(key)" align="right">
                      <span v-if="isNaN(Number(detailedItem[key]))">{{detailedItem[key]}}</span>
                      <span class="col-sm-6" v-if="!isNaN(Number(detailedItem[key]))">{{formatter.format(detailedItem[key])}}</span>
                    </CCol> 
                  </CRow>                 
                </CContainer>
            </template>
            <template v-slot:footer>
              <CButton
                color="info"
                square 
                class="mr-2 d-inline-block"
                @click="
                  detailModal=false
                  detailedItem={}">
                OK
              </CButton>
            </template>
    </CModal>
    <CElementCover v-show="loading"/>
  </CContainer>
</template>

<script>
  import JsonExcel from "vue-json-excel";
  import { formatter, replace_ } from "@/general";
  import {dataGridEstadoCuentaCliente} from "@/api";

const fields = [
  { _style: 'text-align:center;', key: 'Documento' },
  { _style: 'text-align:center;', key: 'Fecha_Emision', label:'Fecha Emision' },
  { _style: 'text-align:center;', key: 'Fecha_Vencimiento', label:'Fecha Vencimiento' },
  { _style: 'text-align:center;', key: 'Valor_Saldo', label:'Valor Saldo' },
  { _style: 'text-align:center;', key: 'Tipo_Documento', label:'Tipo Documento' },
  { _style: 'text-align:center;', key: 'btn', label: '' }
]

const fileFields = {
  'Documento': 'Documento',
  'Fecha Emision': 'Fecha_Emision',
  'Fecha Vencimiento': 'Fecha_Vencimiento',
  'Valor Saldo': 'Valor_Saldo',
  'Tipo Documento': 'Tipo_Documento',
  'Valor ReteIVA': 'Valor_ReteIVA',
  'Valor ReteFuente': 'Valor_ReteFuente',
  'Valor ReteICA': 'Valor_ReteICA',
  'Valor Abonos': 'Valor_Abonos',
  'Valor Total': 'Valor_Total'
}

export default {
   name: 'AccountStatus',
   data () {
    return {
      items:[],
      fields,
      fileFields,
      formatter,
      detailedItem:{},
      detailModal: false,
      loading: false,
      renderExceptions: [ '', 'Id_Documento']
    }
  },
  components:{
    JsonExcel
  },
  methods:{
    async getData() {
      try {
        this.loading = true
        const response = await dataGridEstadoCuentaCliente(this, this.$store.state.user.data.id_Directorio)
        this.items = response
      } catch {
        this.$store.commit('setAlert', {
          color: "danger",
          message: 'Error al cargar datos',
          show: 5
        })
      } finally {
        this.loading = false
      }        
    },
    replace_
  }, 
  mounted(){
    this.getData()
  } 
}
</script>